export const termsText = 'terms.serviceText';

export const privacyText = 'terms.privacyText';
